import { AccountsGridWebComponent } from './component/AccountsGridWebComponent';
import { WEB_COMPONENT_ACCOUNTS_GRID } from '../../webcomponents.constants';

export { AccountsGridWebComponent };

window.customElements.define(WEB_COMPONENT_ACCOUNTS_GRID, AccountsGridWebComponent);
